export default () => (
  <svg
    width="27"
    height="26"
    viewBox="0 0 27 26"
    fill="black"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.9487 25.4487C25.5811 25.8162 25.1458 26 24.6429 26H2.35714C1.85417 26 1.4189 25.8162 1.05134 25.4487C0.68378 25.0811 0.5 24.6458 0.5 24.1429V1.85714C0.5 1.35417 0.68378 0.918898 1.05134 0.551339C1.4189 0.18378 1.85417 0 2.35714 0H24.6429C25.1458 0 25.5811 0.18378 25.9487 0.551339C26.3162 0.918898 26.5 1.35417 26.5 1.85714V24.1429C26.5 24.6458 26.3162 25.0811 25.9487 25.4487ZM5.07143 7.4026C5.45238 7.80087 5.91991 8 6.47403 8C7.02814 8 7.50433 7.80087 7.9026 7.4026C8.30087 7.00433 8.5 6.5368 8.5 6C8.5 5.4632 8.30087 4.99567 7.9026 4.5974C7.50433 4.19913 7.02814 4 6.47403 4C5.91991 4 5.45238 4.19913 5.07143 4.5974C4.69048 4.99567 4.5 5.4632 4.5 6C4.5 6.5368 4.69048 7.00433 5.07143 7.4026ZM14.3261 22H10.5V9.2968H14.2101V11.0183H14.2681C14.5386 10.4642 14.9638 10.0091 15.5435 9.65297C16.2391 9.21766 17.0314 9 17.9203 9C19.6981 9 20.9541 9.57382 21.6884 10.7215C22.2295 11.6317 22.5 13.0761 22.5 15.0548V22H18.6739V15.8265C18.6739 14.7976 18.5773 14.0457 18.3841 13.5708C18.1135 12.8189 17.5338 12.4429 16.6449 12.4429C15.756 12.4429 15.1184 12.7793 14.7319 13.4521C14.4614 13.9665 14.3261 14.7184 14.3261 15.7078V22ZM4.5 22H8.5V10H4.5V22Z"
      fill="inherit"
    />
  </svg>
);
